/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Lede_3Inputs */

const en_home_hero_lede_3 = /** @type {(inputs: Home_Hero_Lede_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in your tools, inside limits you agree.`)
};

const lv_home_hero_lede_3 = /** @type {(inputs: Home_Hero_Lede_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu rīkos un Jūsu noteiktās robežās.`)
};

/**
* | output |
* | --- |
* | "in your tools, inside limits you agree." |
*
* @param {Home_Hero_Lede_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_hero_lede_3 = /** @type {((inputs?: Home_Hero_Lede_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Lede_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_hero_lede_3(inputs)
	return en_home_hero_lede_3(inputs)
});